<template>
  <div class="permisionRow fullWidth fCol aCenter jStart">
    <!-- loading  -->
    <div v-bind:class="{open: whileLoading}" class="load fCol aCenter jCenter">
      <i class="material-icons-round fCol aCenter jCenter">loop</i>
    </div>

    <!-- main item renders here ↓ -->
    <access-item
      @details="handleDetails"
      @edit="goEditAccess($event)"
      :data="data" />

    <!-- arrow -->
    <div class="arrow" v-bind:class="{open: expanded}"
      @click="handleDetails">
      <i class="material-icons-round">keyboard_arrow_down</i>
    </div>

    <!-- expand list render here ↓ -->
    <div class="expandList fullWidth fCol jStart aStart"
      v-if="permissionsLoaded">
      <div class="fullWidth text-right tt">جزئیات مجوزها:</div>
      <div v-for="(item, index) in permissionsData"
        v-bind:key="index"
        class="fRow jStart aCenter wrap fullWidth ppp">
        <div class="t fullWidth">لیست مجوزهای مربوط به {{item[0].parent.title}}:</div>
        <div class="fRow jStart aStart permissionCheap"
          v-for="(itm, indx) in item" v-bind:key="indx">
          <i class="material-icons-round">{{itm.icon}}</i>
          <div class="cheapLabel">{{itm.title}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccessItem from '@/components/AccessItem.vue';
import axios from 'axios';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';

export default {
  mixins: [errorHandler, makeToast],
  data() {
    return {
      expanded: false,
      whileLoading: false,
      expndHeight: 0,
      isDataLoaded: false,
      pTtl: '',
      pIcn: '',
      boxHeight: 88,
      accessData: [],
      accArray: this.accessArray,
      permissionsData: [],
      isPermissionsLoaded: false,
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      permissionsLoaded: false,
      editMode: false,
    };
  },
  computed: {},
  props: ['data', 'accessArray'],
  methods: {
    goEditAccess(e) {
      this.$emit('edit', e);
    },
    expandRow() {
      // const expaand = document.getElementById('expnd');
      if (this.$store.state.letExpand) {
        if (this.expanded) {
          this.expanded = false;
          this.boxHeight = 88;
          this.expndHeight = 88;
        } else {
          this.expanded = true;
          // const h = document.getElementById('expnd').scrollHeight;
          // console.log('h', h + 88);
          this.expndHeight = (this.permissionsData.length * 34) + 148;
          this.boxHeight = 88;
        }
      }
    },
    handleDetails() {
      if (this.permissionsLoaded) {
        this.permissionsLoaded = false;
      } else {
        this.getAccessPermissions();
      }
    },
    getAccessPermissions() {
      // console.log(this.accessArray);
      this.permissionsLoaded = false;
      axios({
        method: 'get',
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
        url: `${this.baseURL}/api/v${this.V}/Accesses/permission/${this.data.id}`,
      }).then((response) => {
        // console.log('return from ids', this.posts);
        this.whileLoading = false;
        if (response.data.isSuccess) {
          this.permissionsData = response.data.data;
          this.permissionsLoaded = true;
          console.log(this.permissionsData);
          // this.expandRow();
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
      });
      // if (this.$store.state.letExpand) {
      //   // اگر بسته بود
      //   if (this.expanded === false) {
      //     // اگر زیر مجموعه داست
      //     this.whileLoading = true;
      //   } else {
      //     this.expandRow();
      //   }
      // }
    },
    // send access permissions to access group init
  },
  components: {
    AccessItem,
  },
  mounted() {
    this.accessData = this.data;
    console.log(this.data);
    // console.log(this.permissionsData);
  },
};
</script>

<style lang="scss" scoped>

.permisionRow {
  transition: all cubic-bezier(0.5,0,0,1) 0.5s;
  border-radius: 0px;
  overflow: auto;
  position: relative;
  margin: 4px 0px;
  border-right: solid 2px var(--normalText1);
}

.permisionRow .load{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 72px;
  display: none;
  background-color: var(--normalText7);
}

.permisionRow.opened{
  background-color: rgba($color: #000000, $alpha: 0.05) !important;
  margin: 8px 0px;
  border-right: solid 2px #00000069;
  overflow: hidden;
  border-radius: 0px !important;
}

.permisionRow .arrow{
  position: absolute;
  transform: translateY(-50%) rotate(0deg);
  top: 36px;
  right: 8px;
  height: 16px;
  width: 16px;
  transition: all cubic-bezier(0.5, 0, 0, 1) 0.3s;
  pointer-events: none;
}

.arrow i{
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.arrow.open {
  transform: translateY(-50%) rotate(-180deg);
}

.expandList{
    transform-origin: top center;
    overflow: hidden;
    padding: 16px;
    align-content: flex-start;
    background-color: rgba($color: #000000, $alpha: 0.05);
    transition: all cubic-bezier(0.5,0,0,1) 0.5s;
}

.tt {
  font-size: 12px;
  font-weight: 200;
  margin-bottom: 16px;
  color: var(--normalText);
}

.load{
  z-index: 3000;
  height: 88px;
}

.load.open {
  display: flex;
  height: 88px;
}

.load i{
  width: 16px;
  height: 16px;
  display: flex;
  border-radius: 50%;
  background-color: rgba($color: #000000, $alpha: 0.25);
  font-size: 12px;
  animation: loadi infinite cubic-bezier(1,0,0,1) 1s;
}

.ppp {
  padding: 8px 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  border: solid 1px rgba($color: #000000, $alpha: 0.05);
  .t {
    text-align: right;
    font-size: 14px;
    margin-bottom: 8px;
    color: var(--normalText8);
  }
  .permissionCheap {
    border-radius: 64px;
    padding: 4px 12px;
    margin: 0 0 8px 8px;
    background-color: var(--invertText2);
    i{
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      color: var(--normalText5);
    }
    .cheapLabel{
      font-size: 12px;
      font-weight: 300;
      color: #121212;
      margin-right: 8px;
      white-space: nowrap;
      color: var(--normalText5);
    }
  }
}
.ppp:last-child {
  margin-bottom: 0;
}

@keyframes loadi{
  0%{
    box-shadow: 0 0 0 8px rgba($color: #000000, $alpha: 0.05);
    transform: rotate(0deg);
  }
  50%{
    box-shadow: 0 0 0 16px rgba($color: #000000, $alpha: 0.15);
  }
  100%{
    box-shadow: 0 0 0 8px rgba($color: #000000, $alpha: 0.05);
    transform: rotate(-360deg);
  }
}

</style>
